import React from 'react'

export default function CreateCampaign() {
  return (
    <div>
      <h1>CreateCmpaign</h1>
    </div>
  )
}
